import { render, staticRenderFns } from "./ScrollToTopButton.vue?vue&type=template&id=61f694ec"
import script from "./ScrollToTopButton.vue?vue&type=script&lang=ts"
export * from "./ScrollToTopButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports